/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Customer } from './Customer';
import {
    CustomerFromJSON,
    CustomerFromJSONTyped,
    CustomerToJSON,
    CustomerToJSONTyped,
} from './Customer';
import type { ResponseResult } from './ResponseResult';
import {
    ResponseResultFromJSON,
    ResponseResultFromJSONTyped,
    ResponseResultToJSON,
    ResponseResultToJSONTyped,
} from './ResponseResult';

/**
 * 
 * @export
 * @interface ResponseCustomer
 */
export interface ResponseCustomer {
    /**
     * 
     * @type {ResponseResult}
     * @memberof ResponseCustomer
     */
    result: ResponseResult;
    /**
     * 
     * @type {Customer}
     * @memberof ResponseCustomer
     */
    data: Customer;
}

/**
 * Check if a given object implements the ResponseCustomer interface.
 */
export function instanceOfResponseCustomer(value: object): value is ResponseCustomer {
    if (!('result' in value) || value['result'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ResponseCustomerFromJSON(json: any): ResponseCustomer {
    return ResponseCustomerFromJSONTyped(json, false);
}

export function ResponseCustomerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseCustomer {
    if (json == null) {
        return json;
    }
    return {
        
        'result': ResponseResultFromJSON(json['result']),
        'data': CustomerFromJSON(json['data']),
    };
}

export function ResponseCustomerToJSON(json: any): ResponseCustomer {
    return ResponseCustomerToJSONTyped(json, false);
}

export function ResponseCustomerToJSONTyped(value?: ResponseCustomer | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'result': ResponseResultToJSON(value['result']),
        'data': CustomerToJSON(value['data']),
    };
}

